(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    // Scope viewport tracking to the search dialog; leave other dialogs alone.
  (() => {
    const modal = document.getElementById('search-modal');
    const dialog = modal?.querySelector('dialog');
    const input = modal?.querySelector('input.search-input');
    const header = modal?.querySelector('.predictive-search-form__header');
    if (!dialog || !input || !header) return;

    const mobile = window.matchMedia('(max-width: 749px)');
    const viewport = window.visualViewport;
    let controller;
    let frame = 0;
    let baselineWidth = window.innerWidth;
    let baselineHeight = window.innerHeight;

    const clearSizing = () => {
      dialog.style.removeProperty('--mobile-search-viewport-height');
      dialog.style.removeProperty('--mobile-search-viewport-top');
      dialog.style.removeProperty('--mobile-search-header-height');
      dialog.removeAttribute('data-mobile-search-compact');
    };

    const update = () => {
      frame = 0;
      if (!dialog.open || !mobile.matches || (viewport && Math.abs(viewport.scale - 1) > 0.05)) {
        clearSizing();
        return;
      }

      const height = viewport?.height ?? window.innerHeight;
      const top = viewport?.offsetTop ?? 0;
      if (Math.abs(window.innerWidth - baselineWidth) > 40) {
        baselineWidth = window.innerWidth;
        baselineHeight = window.innerHeight;
      }
      baselineHeight = Math.max(baselineHeight, window.innerHeight, height);
      const reducedHeight = baselineHeight - height > 120;
      const compact = reducedHeight || (document.activeElement === input && height < 430);

      dialog.style.setProperty('--mobile-search-viewport-height', `${height}px`);
      dialog.style.setProperty('--mobile-search-viewport-top', `${top}px`);
      dialog.style.setProperty('--mobile-search-header-height', `${header.getBoundingClientRect().height}px`);
      dialog.toggleAttribute('data-mobile-search-compact', compact);
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    const stop = () => {
      controller?.abort();
      controller = undefined;
      cancelAnimationFrame(frame);
      frame = 0;
      clearSizing();
    };

    const start = () => {
      if (!dialog.open || controller) return;
      controller = new AbortController();
      const options = { passive: true, signal: controller.signal };
      baselineWidth = window.innerWidth;
      baselineHeight = window.innerHeight;
      viewport?.addEventListener('resize', schedule, options);
      viewport?.addEventListener('scroll', schedule, options);
      window.addEventListener('resize', schedule, options);
      dialog.addEventListener('focusin', schedule, options);
      dialog.addEventListener('focusout', schedule, options);
      update();
    };

    // Observing open also handles native dialog closing and repeat openings.
    new MutationObserver(() => {
      if (dialog.open) start();
      else stop();
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    dialog.addEventListener('close', stop);
    if (dialog.open) start();
  })();
  } catch(e) { console.error(e); }
})();

})();
